<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="info">
            <b-navbar-brand>
                <router-link to="/" class="typo-link-white">S-Print</router-link>
            </b-navbar-brand>

            <template v-if="sessionStoreState.authenticated">

                <div class="typo-white">
                    <span class="mr-3">|</span>
                    <span>Marché actif : </span>
                    <span v-if="marches.length === 0">Tous les marchés</span>
                    <span v-if="marches.length === 1">{{marches[0].text}}</span>
                </div>

                <b-col cols="3" v-if="marches.length > 1">
                    <b-form-select
                            v-model="sessionStoreState.marche"
                            :options="marches"
                            @change="marcheChange"
                    ></b-form-select>
                </b-col>

            </template>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <template v-if="sessionStoreState.authenticated">
                        <div class="typo-white pt-2" v-b-tooltip.hover
                             :title="printRoles">{{printIdentifiant}}</div>
                        <b-nav-item-dropdown right>
                            <template v-slot:button-content>
                                <Icon icon="user-circle" size="1x" style="color: white"></Icon>
                            </template>
                            <b-dropdown-item @click="disconnect()">Déconnexion</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </template>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
  import SessionStore from '@/stores/SessionStore'
  import {EventBus} from '@/event-bus'
  import {RoleEnum} from "../constants/enums";

  export default {
    name: 'NavBar',
    data() {
      return {
        sessionStoreState: SessionStore.state,
      }
    },
    computed: {
      printIdentifiant() {
        if (this.sessionStoreState.nom && this.sessionStoreState.prenom) {
          return `${this.sessionStoreState.prenom} ${this.sessionStoreState.nom}`;
        }  else {
          return this.sessionStoreState.username;
        }
      },
      printRoles() {
        return this.sessionStoreState.roles.map(role => RoleEnum[role]).join(', ');
      },
      marches() {
        return this.sessionStoreState.marches.map(value => {
          return {text: `${value.reference} (${value.libelleCourt})`, value: value}
        });
      }
    },
    methods: {
      marcheChange() {
        EventBus.$emit('NavBar-marcheChange');
      },
      disconnect() {
        SessionStore.disconnect().then(() => this.$router.push("/login")).finally(() => SessionStore.resetInfos());
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../assets/style/base/colors";

  .navbar.navbar-dark.bg-info{
    background-color: $sgp-blue!important;
  }

</style>
